/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetQuickLinksResponseSchema } from '../../entities/schemas/GetQuickLinksResponseSchema';

export type TGetQuickLinksModel = IModel<IGetQuickLinksRequest, TGetQuickLinksResponse>;

export interface IGetQuickLinksRequest {
  /** поисковый запрос в виде json **/
  jsonQuery: any;
}

export type TGetQuickLinksResponse = IGetQuickLinksResponse200 | IGetQuickLinksResponse400;

export interface IGetQuickLinksResponse200 extends IModelResponse<IGetQuickLinksResponse> {
  statusCode: 200;
}

export interface IGetQuickLinksResponse400 extends IModelResponse<IGetQuickLinksResponseError> {
  statusCode: 400;
}

export interface IGetQuickLinksResponse {
  data: IGetQuickLinksResponseSchema;
  status: EStatus;
}

export interface IGetQuickLinksResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetQuickLinksResponse | IGetQuickLinksResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetQuickLinksResponse): TResponse200;
  400(response: IGetQuickLinksResponseError): TResponse400;
}
